import { useAutocompleteSource } from '@eas/common-web';
import { DictProposerTypeAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useProposerTypes() {
  return useAutocompleteSource<DictProposerTypeAutocomplete>({
    url: `${EvidenceApiUrl.DICT_PROPOSER_TYPE}/autocomplete`,
  });
}
